import { AlertCircle } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { type DriverMvrState, MvrStatus } from '../../models/mvr'

/** Why the newest pull failed or found nothing, and what to do next. The wording comes from the
 * backend, which also uses it in the Slack notice. */
export function MvrOutcome({ state }: { state: DriverMvrState }) {
  const noRecord = state.latestStatus === MvrStatus.NO_RECORD
  // The backend always sends a label for these statuses; this only covers an older response.
  const label = state.latestOutcomeLabel ?? (noRecord ? 'No record found' : 'Failed')
  return (
    // Table cells keep text on one line; the advice wraps within a bounded width instead of
    // widening the request dialog's table.
    <span className="flex max-w-64 flex-col items-start gap-0.5 text-xs whitespace-normal">
      {noRecord ? (
        <Badge variant="destructive">{label}</Badge>
      ) : (
        <span className="text-destructive flex items-center gap-1.5">
          <AlertCircle className="size-3.5 shrink-0" />
          {label}
        </span>
      )}
      {state.latestNextStep && <span className="text-muted-foreground">{state.latestNextStep}</span>}
    </span>
  )
}
